module.exports = __webpack_public_path__ + "img/illustration_eye_done.393c8645.png";